import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/BillOfLading/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__heading-box')}>
          <h1 className={cn('header__heading')}>Bill of Lading</h1>
          <p className={cn('header__description')}>
            This comprehensive guide on Bill of Lading explains why this critical document underpins
            global trade and logistics, for all the professionals involved as well as the end customer-
            covering detailed insights into the types, legal implications, and best practices for managing
            Bills of Lading, empowering <Link href='/freight-forwarder'>freight forwarders</Link> and NVOCC managers to streamline their
            shipping processes and ensure compliance.
          </p>
        </div>

        <div className={cn('header__image-box')}>
          <img
            className={cn('header__image')}
            src="/images/pages/Resources/BillOfLading/bill.png"
            srcSet="/images/pages/Resources/BillOfLading/bill.png 1x,
                    /images/pages/Resources/BillOfLading/bill@2x.png 2x"
            alt="bill"
          />
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;